<div class="container-fluid">
    <app-header></app-header>

    <div class="row mt-3 d-flex justify-content-center signup-card">
        <div class="col-12">
            <div class="text-center box-white">
                <div class="row">
                    <div class="col-12 text-left pb-2">
                        <h5>Account statement</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 text-left">
                        <div class="row">
                            <div class="pr-2 col-xl-auto">
                                <p style="line-height: 38px; margin-bottom: 0px">Period</p>
                            </div>
                            <div class="col-xl-auto">
                                <select class="form-control dropdown-fix dropdown-width"
                                    (change)="changeCity($event.target.value)" style="width: 100%">
                                    <option value="{{ periods.from }},{{ periods.to }}"
                                        *ngFor="let periods of this.period">
                                        {{ periods.period }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div class="finance" style="overflow: auto">
                    <div class="box pl-4 pt-4 pr-4 pb-4" style="width: max-content; min-width: 100%">
                        <div class="row">
                            <div class="col-2">
                                <p class="text-left"><b>Orders</b></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Total Order Value</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">
                                    {{ twodecimal(orderNetMerchandiseValue) }} LKR
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <p class="text-left"></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Merchant Commission Fee</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">{{ twodecimal(orderCommission) }} LKR</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <p></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Payment Fee</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">
                                    {{ twodecimal(orderProcessingFee) }} LKR
                                </p>
                            </div>
                        </div>
                        <div *ngFor="let tax of taxDetails" class="row">
                            <div class="col-2"></div>
                            <div class="col-4">
                                <p class="text-left">
                                    {{ tax.taxStructure.type }}
                                </p>
                            </div>
                            <div class="col-6">
                                <div class="row">
                                    <p class="col-12 text-right">{{ tax.orderTaxFee }} LKR</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2">
                                <p></p>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-6">
                                <div class="row">
                                    <p class="col-6 text-right"></p>
                                    <p class="col-3 text-right pt-3" style="border-top: 1px solid #cfcfcf">
                                        <b>Subtotal</b>
                                    </p>
                                    <p class="col-3 text-right pt-3" style="border-top: 1px solid #cfcfcf">
                                        {{ twodecimal(this.orderTotal) }} LKR
                                    </p>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div class="row">
                            <div class="col-2">
                                <p class="text-left"><b>Refunds</b></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Total Order Value</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">
                                    {{ twodecimal(this.refundNetMerchandiseValue) }} LKR
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <p></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Merchant Commission Fee</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">
                                    {{ twodecimal(this.refundCommission) }} LKR
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-2">
                                <p></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Payment Fee</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">
                                    {{ twodecimal(this.refundProcessingFee) }} LKR
                                </p>
                            </div>
                        </div>

                        <div *ngFor="let tax of taxDetails" class="row">
                            <div class="col-2"></div>
                            <div class="col-4">
                                <p class="text-left">
                                    {{ tax.taxStructure.type }}
                                </p>
                            </div>
                            <div class="col-6">
                                <div class="row">
                                    <p class="col-12 text-right">{{ tax.refundTaxFee }} LKR</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2">
                                <p></p>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-6">
                                <div class="row">
                                    <p class="col-6 text-right"></p>
                                    <p class="col-3 text-right pt-3" style="border-top: 1px solid #cfcfcf">
                                        <b>Subtotal</b>
                                    </p>
                                    <p class="col-3 text-right pt-3" style="border-top: 1px solid #cfcfcf">
                                        {{ twodecimal(this.refundTotal) }} LKR
                                    </p>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-2">
                                <p class="text-left"><b>Closing balance</b></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">Total balance</p>
                            </div>
                            <div class="col-6">
                                <p class="text-right">
                                    {{ twodecimal(this.closingBalance) }} LKR
                                </p>
                            </div>
                        </div>

                        <hr />
                        <div class="row">
                            <div class="col-2">
                                <p class="text-left"><b>Payout</b></p>
                            </div>
                            <div class="col-4">
                                <p class="text-left">
                                    It will take approximately 4-5 days to reflect in your account
                                    statement.
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="text-right"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="foter-mr-pd-fix">
    <app-footer></app-footer>
</div>